const languageToIdMapping: { [key: string]: string } = {
    "Arabic": "ar-EG",
    "Chinese": "cmn-Hans-CN",
    "English": "en-US",
    "French": "fr-FR",
    "German": "de-DE",
    "Italian": "it-IT",
    "Japanese": "ja-JP",
    "Korean": "ko-KR",
    "Portuguese": "pt-BR",
    "Russian": "ru-RU",
    "Spanish": "es-US"
};

export default languageToIdMapping;